import type { Store } from "@inferno/renderer-shared-core";
import type { IHeartAppsFlyerSDK, AppsFlyerConfigRegistry } from "@iheartradio/web.appsflyer-sdk";
import { ILog } from "@ihr-radioedit/inferno-core";

const log = ILog.logger("appsflyer-init");

export function initAppsFlyer(store: Store): boolean {
  try {
    const sdk = window.iHeartAppsFlyer as IHeartAppsFlyerSDK | undefined;
    if (!sdk) {
      log.debug("AppsFlyer SDK not loaded");
      return false;
    }

    const config: AppsFlyerConfigRegistry = {
      Talkback: {
        oneLinkURL: "https://iheart.onelink.me/Ff5B/TalkbackLocal",
        afParameters: {
          mediaSource: {
            keys: ["utm_mediasource"],
            defaultValue: "inferno-local",
          },
          campaign: {
            keys: ["utm_campaign"],
            defaultValue: "Talkback",
          },
        },
      },
    };

    sdk.init({
      debug: window.SDK.environment.NODE_ENV === "development" || window.SDK.environment.LOG_LEVEL === "debug",
      config,
    });

    log.debug("AppsFlyer SDK initialized successfully", {
      talkback: store.site.isTalkbackEnabled,
    });

    return true;
  } catch (error) {
    log.error("Failed to initialize AppsFlyer SDK", error);
    return false;
  }
}
